'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';

import cx from 'classnames';
import NextImage from 'next/image';
import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import ButtonCircle from 'components/ui/ButtonCircle';
import EntryLink from 'components/ui/Link/EntryLink';
import Text from 'components/ui/Text';

import { blockRootProps, getColor } from 'utils';
import { addProtocol } from 'utils/url';

import styles from './BlockFeaturedCategoryNavigation.module.scss';

const BlockFeaturedCategoryNavigation = ({
    __typename,
    anchorId,
    headline,
    cta,
    image,
    mediaPosition,
    backgroundColor,
    flushTop,
    flushBottom,
    links,
}) => {
    mediaPosition ??= 'Left';

    const hasImage = image?.url;
    const isRight = mediaPosition.toLowerCase() === 'right';

    const [hoveredIndex, setHoveredIndex] = useState(null);

    return (
        <section
            style={
                backgroundColor
                    ? {
                          '--background-color': getColor(backgroundColor),
                      }
                    : undefined
            }
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, {
                [styles.imageRight]: isRight,
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.media}>
                    <div className={styles.imageWrapper}>
                        {hasImage && (
                            <NextImage
                                className={cx(styles.image, {
                                    [styles.imageHidden]: hoveredIndex !== null,
                                })}
                                src={addProtocol(image.url)}
                                sizes="(max-width: 768px) 100vw, 50vw"
                                width={image.width}
                                height={image.height}
                                alt={image.description || image.title || ''}
                            />
                        )}
                        {links?.map(
                            (item, i) =>
                                item.hoverImage?.url && (
                                    <NextImage
                                        key={i}
                                        className={cx(
                                            styles.image,
                                            styles.hoverImage,
                                            {
                                                [styles.hoverImageActive]:
                                                    hoveredIndex === i,
                                            }
                                        )}
                                        src={addProtocol(item.hoverImage.url)}
                                        sizes="(max-width: 768px) 100vw, 50vw"
                                        width={item.hoverImage.width}
                                        height={item.hoverImage.height}
                                        alt={
                                            item.hoverImage.description ||
                                            item.hoverImage.title ||
                                            ''
                                        }
                                    />
                                )
                        )}
                    </div>
                </div>
                <div className={styles.card}>
                    {(headline || cta) && (
                        <div className={styles.heading}>
                            {headline && (
                                <Text
                                    as="h2"
                                    baseTheme="displayXSmall"
                                    themes={{ large: 'displayLarge' }}
                                    className={styles.headline}
                                >
                                    {headline}
                                </Text>
                            )}
                            {cta && (
                                <div className={styles.cta}>
                                    <ButtonCTA {...cta} />
                                </div>
                            )}
                        </div>
                    )}
                    {links?.length > 0 && (
                        <div className={styles.linkList}>
                            {links.map((item, i) => (
                                <EntryLink
                                    key={i}
                                    entry={item.link}
                                    className={styles.linkItem}
                                    onMouseEnter={() => setHoveredIndex(i)}
                                    onMouseLeave={() => setHoveredIndex(null)}
                                >
                                    <span className={styles.linkItemLabel}>
                                        {item.title}
                                        {item.new && (
                                            <span className={styles.newBadge}>
                                                NEW!
                                            </span>
                                        )}
                                    </span>
                                    <ButtonCircle
                                        as="span"
                                        aria-hidden="true"
                                        className={styles.circleButton}
                                        theme="small-fill-white"
                                        iconType="chevronRight"
                                    >
                                        <span />
                                    </ButtonCircle>
                                </EntryLink>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

BlockFeaturedCategoryNavigation.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    backgroundColor: PropTypes.string,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    cta: PropTypes.object,
    headline: PropTypes.string,
    image: PropTypes.shape({
        description: PropTypes.string,
        height: PropTypes.number,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number,
    }),
    links: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.shape({
                description: PropTypes.string,
                height: PropTypes.number,
                title: PropTypes.string,
                url: PropTypes.string,
                width: PropTypes.number,
            }),
            link: PropTypes.object,
            new: PropTypes.bool,
            title: PropTypes.string,
        })
    ),
    mediaPosition: PropTypes.oneOf(['Left', 'Right']),
};

export default BlockFeaturedCategoryNavigation;
